<template>
    <div style="background-color:white ;height:400px"
         class="d-flex align-items-center justify-content-center">            
        <div>
            <div class="mb-4">                
                {{$t('s_accesdenied_needed_loggedin')}}
            </div>
            <div class="d-flex flex-column align-items-center justify-content-center;">
                <div @click="app.auth.tryLogin()">
                    <button class="btn btn-primary loginButton">
                        {{$t('register_login')}}
                    </button>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
import { app } from "../application.js";

export default {
    name: "accessDeniedComponent",
    data() {
        return {
            app: app
        };
    },
    mounted() {
        //set language to change label languages
        if (!this.app.currentConfiguration.language) {
            this.app.setLanguageFromBrowser();
        }

        //hide navigationbar
        this.app.showNavigationBar = false;
    }
};
</script>

<style lang="scss">

.loginIcon {
    width: 50px;
    margin: 5px;
    height: auto;
}


</style>



